import { useEffect, useState } from "react"
import { Ideas } from "../../components/ideas/ideas.component"
import { NoIdeaFound } from "../../components/noIdeaFound/noIdeaFound.component"
import { getFeeds } from "../../services/ideas.service"

export const IdeasList = () => {
    const [feeds, setFeeds] = useState([])

    const getData = async () => {
        const { status, data } = await getFeeds()
        if (status == 200) {
            setFeeds(data);
        }
    };
    useEffect(() => {
        getData()
    }, [])
    return (
        <>
            <h2 className="text-uppercase mb-1">
                <span className="star-orange">IDEAS</span> TIMELINE
            </h2>
            {feeds.length == 0 ? <NoIdeaFound heading={"No ideas found !!"} /> : feeds.map((data) => {
                // console.log(data)
                return <Ideas key={data.IDEA_ID} ideaId={data.IDEA_ID} Name={data.EMP_NAME} Desc={data.IDEA_DETAIL} CreatedAt={data.createdAt} Attachments={data.attachments} hearts={data.hearts} likes={data.likes} dislikes={data.dislikes} comments={data.comments} reactionId={data.reactionId} reactionType={data.reactionType} />
            })}
        </>
    )
}